import { t } from "@lingui/macro";
import { useAtomValue, useSetAtom } from "jotai";

import { Button } from "@whoosh/design-system/src/components/controls";
import { PlusIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import { HStack } from "@whoosh/design-system/src/components/primitive";

import { getBookingPlayerNoun } from "../../../../../BookingSummary/utils/getBookingPlayerNoun";
import { enterAddPlayersStepAtom } from "../../../../atoms/actions/EnterAddPlayersStepAtom/enterAddPlayersStepAtom";
import { enterAddPlayersPrivateStepAtom } from "../../../../atoms/actions/enterAddPlayersPrivateStepAtom/enterAddPlayersPrivateStepAtom";
import { canAddAdditionalRoundsAtom } from "../../../../atoms/selectors/canAddAdditionalRoundsAtom/canAddAdditionalRoundsAtom";
import { currentBookingAtom } from "../../../../atoms/stores";

type Props = {
  isPrivate: boolean;
  bookingIndex?: number;
};

export const AddPlayerButton = ({ isPrivate, bookingIndex }: Props) => {
  const canAddRounds = useAtomValue(canAddAdditionalRoundsAtom);
  const currentBooking = useAtomValue(currentBookingAtom);
  const enterAddPlayersStep = useSetAtom(enterAddPlayersStepAtom);
  const enterAddPlayersPrivateStep = useSetAtom(enterAddPlayersPrivateStepAtom);
  const playerNoun = getBookingPlayerNoun({
    bookingType: currentBooking?.type,
    copyOverrides: currentBooking?.copyOverrides,
  });
  const isTargetGroupFull =
    bookingIndex != null &&
    currentBooking?.groupCapacity != null &&
    (currentBooking.rounds.filter(
      (round) => (round.bookingIndex ?? 0) === bookingIndex
    ).length ?? 0) >= currentBooking.groupCapacity;

  const handleAddPlayer = () => {
    if (isPrivate) {
      enterAddPlayersPrivateStep({ bookingIndex });
    } else {
      enterAddPlayersStep({ bookingIndex });
    }
  };

  return canAddRounds && !isTargetGroupFull ? (
    <HStack paddingHorizontal={5} width="100%">
      <Button
        accessibilityLabel={t`Add ${playerNoun.singular}`}
        onPress={handleAddPlayer}
        variant="outline"
        leftIcon={<PlusIcon />}
        width="100%"
      >
        {t`Add ${playerNoun.singular}`}
      </Button>
    </HStack>
  ) : null;
};
